import { UtmSnapshot } from "./types";
import { getCookie, setCookie } from "./cookies";

export function parseUtmFromUrl(url: string): { utm?: UtmSnapshot; fbclid?: string; gclid?: string } {
  const u = new URL(url);
  const get = (k: string) => u.searchParams.get(k) ?? undefined;
  const utm: UtmSnapshot = {
    source:   get("utm_source"),
    medium:   get("utm_medium"),
    campaign: get("utm_campaign"),
    content:  get("utm_content"),
    term:     get("utm_term"),
  };
  const hasUtm = Object.values(utm).some(Boolean);
  return {
    utm: hasUtm ? utm : undefined,
    fbclid: get("fbclid"),
    gclid:  get("gclid"),
  };
}

const FIRST_COOKIE = "_sx_first";
const LAST_COOKIE = "_sx_last";
const TTL_DAYS = 90;

export function captureAttribution() {
  const { utm, fbclid, gclid } = parseUtmFromUrl(location.href);
  if (utm) {
    if (!getCookie(FIRST_COOKIE)) {
      setCookie(FIRST_COOKIE, JSON.stringify(utm), TTL_DAYS);
    }
    setCookie(LAST_COOKIE, JSON.stringify(utm), TTL_DAYS);
  }
  return { fbclid, gclid };
}

export function getAttribution() {
  const first = getCookie(FIRST_COOKIE);
  const last = getCookie(LAST_COOKIE);
  return {
    first_utm: first ? JSON.parse(first) : undefined,
    last_utm: last ? JSON.parse(last) : undefined,
  };
}
